import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnLoginPageComponent } from './dn-login-page.component';

import { LoginService } from '../../core/service/login/login.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DatanyzeCommonModule } from '../../../datanyze-common.module';
import { NyzeAnimationModule } from '../../../nyze.module';
import { ValidationService } from '../../../service/validation/validation.service';
import { ConfigService } from '../../core/service/config.service';
import { CommonService } from '../../core/service/common.service';
import { DirectivesModule } from '../../core/directives/directives.module';
import { NyzeContainerModule } from '../../core/components/nyze-container/nyze-container.module';
import { GoogleService } from '../../core/service/oauth2/google.service';
import { Office365Service } from '../../core/service/oauth2/office365.service';

@NgModule({
  declarations: [DnLoginPageComponent],
    imports: [
        CommonModule,
        DatanyzeCommonModule,
        FormsModule,
        ReactiveFormsModule,
        NyzeAnimationModule,
        DirectivesModule,
        NyzeContainerModule,

    ],
  providers: [
    ConfigService,
    CommonService,
    LoginService,
    ValidationService,
    GoogleService,
    Office365Service,

  ],
  exports: [DnLoginPageComponent],
})
export class DnLoginPageModule {}
